'use client';

import { useEffect } from 'react';
import Link from 'next/link';

// Segment error boundary: an uncaught render/data error inside /inventory
// shows this retryable page instead of Next's bare "Application error" screen.
export default function InventoryError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('Inventory route error:', error);
    }, [error]);

    return (
        <div className="flex flex-col min-h-[80vh]">
            <div className="h-desktop_header_height w-full bg-black"></div>
            <div className="flex-1 flex flex-col items-center justify-center px-4">
                <h1 className="text-6xl font-bold text-gslate mb-4">Oops</h1>
                <h2 className="text-2xl text-gray-600 mb-8">Something went wrong loading the inventory</h2>
                <p className="text-gray-500 mb-8 text-center max-w-md">
                    This is usually temporary. Try again in a moment, or head back to the home page.
                </p>
                <div className="flex gap-4">
                    <button
                        onClick={() => reset()}
                        className="px-6 py-3 bg-gslate text-white rounded-md hover:bg-gslate/90 transition-colors"
                    >
                        Try Again
                    </button>
                    <Link
                        href="/"
                        className="px-6 py-3 border border-gslate text-gslate rounded-md hover:bg-gray-100 transition-colors"
                    >
                        Return Home
                    </Link>
                </div>
                {error?.digest && (
                    <p className="text-xs text-gray-400 mt-8">Reference: {error.digest}</p>
                )}
            </div>
        </div>
    );
}
